<template>
  <div class="brandgoods">
    <!--头部导航-->
    <top-nav ref="TopNav"></top-nav>
    <van-nav-bar :title="branddatas.name" fixed left-arrow @click-left="goBack" @click-right="onClickRight">
      <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar>
    <div class="van-content">
      <!--<van-cell-group class="logoCont"  v-if="branddatas.banner_img">-->
        <!--<van-cell class="bg-fff">-->
          <!--<img style="width: 8rem;height: 8rem" v-lazy="branddatas.banner_img"/>-->
          <!--<p  v-html="branddatas.brief"></p>-->
        <!--</van-cell>-->
      <!--</van-cell-group>-->
      <div class="logoCont">
        <img style="width: 8rem;height: 8rem" :src="branddatas.img" onerror="src='/static/errorimg1.png'"/>
        <p  v-html="branddatas.name"></p>
      </div>
      <!--品牌介绍-->
      <van-cell-group v-if="branddatas.content">
        <van-cell class="bg-fff">品牌介绍</van-cell>
        <van-cell class="bg-fff" v-html="branddatas.content"></van-cell>
      </van-cell-group>
      <!--商品列表-->
      <van-cell-group>
        <div class="nodata text-cent" v-if="finished && datas.goods == ''">
            <img src="/static/images/nodataimg6.png"/>
          <p class="text">暂无商品~</p>
        </div>
        <van-list v-model="loading" :finished="finished" @load="getDatas" class="goodslist">
          <van-cell>商品展示</van-cell>
          <van-cell style="padding: 0;">
            <van-col span="12" v-for="(items,index) in datas" :key="index" style="padding: 10px">
              <router-link :to="{path:'/goodslist/goods',query:{id:items.id}}">
                <img :src="items.product_img"  onerror="src='/static/errorimg1.png'"/>
                <div>
                  <p class="tagbox">
                    <van-tag class="theme-bg theme-bd" v-if="items.is_new == 1">新品</van-tag>
                    <van-tag class="theme-bg theme-bd" v-if="items.is_hot == 1">热销</van-tag>
                    <van-tag class="theme-bg theme-bd" v-if="items.is_rob == 1">限时</van-tag>
                  </p>
                  <p class="ellipse product-name"><van-tag plain class="theme-col theme-bd jd" v-if="items.dummy == 3">优选</van-tag>{{ items.product_name }}</p>
                  <p class="theme-col product-price">{{ items.points_price  }}</p>
                </div>
              </router-link>
            </van-col>
          </van-cell>
        </van-list>
      </van-cell-group>
      <div v-if="!loading && finished && datas.goods != ''" class="nomore">没有更多了~</div>
    </div>
  </div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "brandgoods",
    components: {
      TopNav
    },
    data () {
      return {
        datas:[],
        branddatas:'',
        page:0,
        finished:false,
        loading:false,
        brand_id:this.$route.query.brand_id,
      }
    },
    watch: {
      $route(to,form){
        if(to.name == 'BrandGoods' && this.brand_id != this.$route.query.brand_id){
          this.datas = [];
          this.branddatas = '';
          this.page = 0;
          this.brand_id = this.$route.query.brand_id;
          if(this.finished){
            this.finished = false
          }else{
            this.getDatas()
          }
        }
      }
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      getDatas: function () {
        var isUser = localStorage.getItem("BLHuser");
        var _this = this;
        setTimeout(() => {
          this.page++;
          this.$api.get('WebApi/Product/Product/product_brand', {id:this.brand_id,p:this.page}, res => {
            if(res.data.code == '100'){
              if(res.data.data.goods.length==0){
                _this.finished = true;
                _this.loading = false;
              }else{
                _this.branddatas = res.data.data.brand
                for (let i = 0; i < res.data.data.goods.length; i++) {
                  _this.datas.push(res.data.data.goods[i]);
                }
                _this.loading = false;
              }
            }else{
              this.$toast.alert(res.data.message);
              _this.loading = false;
            }
          })
        },50)
      },
      mounted () {
        this.getDatas()
      },
    }
  }
</script>

<style lang="less" scoped>
 .brandgoods{
   .van-content{
     padding-bottom: 0;
   }
   .van-cell:not(:last-child)::after{
     left: 0;
   }
   .goodslist{
      background: #fff;
     .van-col{
       vertical-align: top;
       float: none;
       display: inline-block;
     }
   }
   .logoCont {
     width: 100%;
     text-align: center;
     background: #fff;
     position: relative;
     padding: 20px 0;
     img {
       margin-bottom: 10px;
     }
   }
   .logoCont:after{
     width: 100%;
     height: 1px;
     content: '';
     bottom: 0;
     left: 0;
     background-color: #e5e5e5;
     position: absolute;
   }
 }

</style>



// WEBPACK FOOTER //
// src/pages/goods/brandgoods.vue